import { render } from "./PriceFilter.vue?vue&type=template&id=56ecda73&scoped=true"
import script from "./PriceFilter.vue?vue&type=script&lang=js"
export * from "./PriceFilter.vue?vue&type=script&lang=js"

import "./PriceFilter.vue?vue&type=style&index=0&id=56ecda73&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ecda73"]])

export default __exports__